import ctl from '@netlify/classnames-template-literals'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Glyphs } from '../../rapid-ui'

export function AuthPromotionalPanel() {
	const { t } = useTranslation('common')

	return (
		<div className="relative h-full w-full">
			{/* Fixed gradient background */}
			<div className="absolute inset-0 bg-gradient-to-br from-[#114BC9] to-[#9810FA]" />

			{/* Scrollable content */}
			<div
				className={ctl(`
					relative h-full overflow-y-auto
					grid px-20 py-10 text-white
					grid-cols-[1fr_auto_1fr]
					grid-rows-[1fr_auto_1fr]
				`)}
			>
				<div className="flex flex-col items-center justify-center" style={{ gridArea: '2 / 2' }}>
					<h1 className="text-4xl font-bold leading-tight mb-6">
						{t('auth.promo.headline')}
					</h1>

					<div className="flex-1 flex justify-center items-center">
						<img
							src="/login-promo.png"
							alt={t('auth.promo.imageAlt')}
							className="w-full max-w-xl xl:max-w-2xl 2xl:max-w-3xl object-contain"
						/>
					</div>

					<div className="space-y-6 mt-6">
						<FeatureItem
							icon={<BoltIcon />}
							title={t('auth.promo.feature1Title')}
							description={t('auth.promo.feature1Description')}
						/>
						<FeatureItem
							icon={<SparklesIcon />}
							title={t('auth.promo.feature2Title')}
							description={t('auth.promo.feature2Description')}
						/>
						<FeatureItem
							icon={<Glyphs.heroiconsSolid.RocketIcon />}
							title={t('auth.promo.feature3Title')}
							description={t('auth.promo.feature3Description')}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}

interface FeatureItemProps {
	icon: ReactNode
	title: string
	description: string
}

function FeatureItem({ icon, title, description }: FeatureItemProps) {
	return (
		<div className="flex items-start gap-4">
			<div className="flex-shrink-0 w-12 h-12 rounded-lg bg-white/20 flex items-center justify-center">
				{icon}
			</div>
			<div>
				<h3 className="font-semibold text-lg">{title}</h3>
				<p className="text-white/80 text-sm">{description}</p>
			</div>
		</div>
	)
}

function BoltIcon() {
	return (
		<svg
			className="w-5 h-5"
			fill="none"
			stroke="currentColor"
			viewBox="0 0 24 24"
			aria-hidden="true"
			focusable="false"
		>
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
		</svg>
	)
}

function SparklesIcon() {
	return (
		<svg
			className="w-5 h-5"
			fill="none"
			stroke="currentColor"
			viewBox="0 0 24 24"
			aria-hidden="true"
			focusable="false"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
			/>
		</svg>
	)
}
